<template>
  <div id="app">
    <router-view />

    <div class="download" v-if=" isShowQrAll">
      <div class="qr" v-if="isShowQr">
        <!-- <img src="./assets/image/download.png" alt="" style="width: 120px;" class="img" /> -->

        <vue-qrcode size="120" :value="qrUrl" />
        <div class="title">
          <p>扫码下载APP</p>
          <p>立即畅享高收益</p>
        </div>

        <div class="close">
          <i class="el-icon-circle-close" @click="isShowQr = false"></i>
        </div>
      </div>

      <div class="link" v-else @click="isShowQr = true">下载APP</div>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'qrcode.vue'

import { test } from '@/api'
import config from '../config/index.js'
import { jsonp } from 'vue-jsonp'

export default {
  name: 'App',
  components: { VueQrcode },
  data() {
    return {
      isShowQr: true,
      qrUrl: `${window.location.hostname}/#/register/download-qr`,
    }
  },

  computed: {
    isShowQrAll() {
      if (new RegExp('^\/register|\/login|\/password_reset|\/tradeWap|\/tradePc').test(this.$route.path)) return false
      return true
    },
  },
  async created() {
    //获取设置域名
    const hostArr = window.location.host.split('.')
    let hostname = ''
    if (hostArr[0] === 'uc') {
      hostname = hostArr[1]
    } else {
      hostname = hostArr.length >= 2 ? hostArr[0] : 'prowayxau'
    }
    // 域名存储store
    if (hostname) {
      this.$store.commit('set_hostname', hostname)
    }
    if (!localStorage.getItem('lang')) {
      this.getIpFromIpify().then(ress => {
        localStorage.setItem('ip', ress.ip)
        localStorage.setItem('ipAddr', ress.data[0]+ress.data[1]+ress.data[2])
        test
          .getIpAddress({
            ip: ress.ip,
          })
          .then(res => {
            if (res.Data) {
              this.$i18n.locale = res.Data
              localStorage.setItem('lang', res.Data)
              sessionStorage.setItem('lang', res.Data)
            }
          })
      })
    }
  },
  methods: {
    async getIpFromIpify() {
      return new Promise(resolve => {
        fetch('https://api.ipshudi.com/ipdata/?token=716c222fc13a282c92fdddf0540a1e9b')
          .then(response => response.json())
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            console.error('Error fetching IP address:', error);
          });})
    },
    async getIpFromQQ() {
      fetch('https://api.ipshudi.com/ipdata/?token=716c222fc13a282c92fdddf0540a1e9b')
        .then(response => response.json())
        .then(data => {
          console.log('Your IP address is:', data);
          return data.ip
        })
        .catch(error => {
          console.error('Error fetching IP address:', error);
        });
      // let res = await new Promise((resolve, reject) => {
      //   jsonp(`https://apis.map.qq.com/ws/location/v1/ip?key=${config.ipKey}`, {
      //     output: 'jsonp',
      //   })
      //     .then(resp => {
      //       resolve(resp)
      //     })
      //     .catch(err => {
      //       console.log(err)
      //     })
      // })
      // if (res.message === 'Success') {
      //   return res.result.ip
      // }
    },
  },
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
}

.container_auto {
  width: 1300px;
  margin: 0 auto;
}

.download {
  position: fixed;
  top: 40%;
  right: 0;
  z-index: 1000;

  .qr {
    position: relative;
    width: 157px;
    height: 203px;
    padding: 12px 0;

    background-color: #f34d4f;
    border-radius: 15px;
    text-align: center;
    color: white;

    .title {
      padding-top: 24px;
      width: 100%;
      p {
        line-height: 1.5;
        margin: 0;
      }
    }

    .close {
      position: absolute;
      bottom: -28px;
      color: #666;
      width: 100%;
      margin: auto;
      font-size: 22px;
      cursor: pointer;
    }
  }

  .link {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #f34d4f;
    border-radius: 10px;
    color: white;
    transform: rotate(90deg);
    letter-spacing: 3px;

    position: relative;
    right: -30px;

    cursor: pointer;
  }
}

.title-header-1 {
  margin-bottom: 22px;
  padding: 8px 0;
  border-bottom: 1px solid #dc0406;
  font-weight: 700;

  position: relative;

  &::before {
    content: '';
    width: 80px;
    height: 3px;
    background-color: #dc0406;
    position: absolute;
    bottom: -2px;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue